<template>
  <div class="user-tab">
    <div class="user-info">
      <div class="avator" @click="changeAvator">
        <img
          :src="
            userInfo.avatar
              ? userInfo.avatar
              : require('./img/defaultAvatar.png')
          "
          alt=""
        />
      </div>
      <div class="nick_name">
        <span>{{ userInfo.nick_name }}</span>
        <!-- <img src="./img/edit.png" alt="" @click="editInfo" /> -->
      </div>
      <div class="name_id">{{ userInfo.id }}</div>
      <div class="money_append">
        <div class="money">
          <div class="top">
            <img :src="require('@/assets/user/diamond.png')" alt="" />
            <div>{{ $t("common.diamondText") }}:</div>
          </div>
          <div class="num">{{ $bigNumber(userInfo.diamond / 100) }}</div>
        </div>
        <span class="line"></span>
        <div class="money">
          <div class="top">
            <img :src="require('@/assets/user/gold.png')" alt="" />
            <div>{{ $t("common.gold") }}:</div>
          </div>
          <div class="num">{{ $bigNumber(userInfo.gold / 100) }}</div>
        </div>
        <!-- <span class="line"></span>
        <div class="money">
          <img style="width: 0.16rem" src="./img/cz.png" alt="" />
          <div style="cursor: pointer" @click="recharge">充值</div>
        </div> -->
        <!-- <span class="line"></span> -->

        <!-- <span class="pay_money" @click="balanceOut()">场馆转出</span> -->
      </div>
    </div>
    <!-- <router-link
      to="/user-center/index"
      active-class="active"
      class="user-item"
    >
      <img
        src="./img/mine_nav_ziliao_on.png"
        alt=""
        v-if="
          $route.path == '/user-center' || $route.path == '/user-center/index'
        "
      />
      <img src="./img/mine_nav_ziliao_nor.png" alt="" v-else />
      <span>{{ $t("pc.userInfo") }}</span>
    </router-link> -->
    <!-- <router-link to="/user-center/myWallet" active-class="active">
      <img src="./img/mine_nav_qianbao_on.png" alt="" v-if="$route.path == '/user-center/myWallet'" />
      <img src="./img/mine_nav_qianbao_nor.png" alt="" v-else />
      <span>我的钱包</span>
    </router-link>
    <router-link to="/user-center/checkin" active-class="active">
      <img src="./img/checked-icon.png" alt="" v-if="$route.path == '/user-center/checkin'" />
      <img src="./img/check-icon.png" alt="" v-else />
      <span>每日签到</span>
    </router-link>
    <router-link v-if="userState == 1" :to="{ path: '/user-center/center-anchor', query: { id: userInfo.id } }" :class="{ activeAnchor: isAnchorCenter }">
      <img src="./img/mine_nav_zhubozhongxin_on.png" alt="" v-if="isAnchorCenter" />
      <img src="./img/mine_nav_zhubozhongxin_nor.png" alt="" v-else />
      <span>主播中心</span>
    </router-link>
    <div class="scd-menu" v-if="isAnchorCenter">
      <router-link :to="{ path: '/user-center/center-anchor', query: { id: userInfo.id } }" active-class="scd-menu-item-active" class="scd-menu-item">
        <div class="scd-menu-item-text">数据分析</div>
      </router-link>
      <router-link :to="{ path: '/user-center/live-room-settings', query: { id: userInfo.id } }" active-class="scd-menu-item-active" class="scd-menu-item">
      <div class="scd-menu-item-text">直播间设置</div>
    </router-link>
      <router-link
        v-if="userInfo.is_guess_host == 1 && appConfig.quiz_factor & 1"
        :to="{ path: '/user-center/guessing-management', query: { id: userInfo.id } }"
        active-class="scd-menu-item-active"
        class="scd-menu-item"
      >
        <div class="scd-menu-item-text">鹰选管理</div>
      </router-link>
    </div>
    <router-link to="/user-center/focus" active-class="active">
      <img src="./img/mine_nav_guanzhu_on.png" alt="" v-if="$route.path == '/user-center/focus'" />
      <img src="./img/mine_nav_guanzhu_nor.png" alt="" v-else />
      <span>我的关注</span>
    </router-link>
    <router-link to="/user-center/mySchedule" active-class="active">
      <img src="./img/mine_nav_yuyue_on.png" alt="" v-if="$route.path == '/user-center/mySchedule'" />
      <img src="./img/mine_nav_yuyue_nor.png" alt="" v-else />
      <span>预约赛事</span>
    </router-link> -->
    <router-link to="/user-center/apply-anchor" active-class="active">
      <img
        :src="require('@/assets/user/tip.png')"
        alt=""
        v-if="$route.path == '/user-center/apply-anchor'"
      />
      <img src="./img/mine_nav_zhubo_nor.png" alt="" v-else />
      <span>{{ $t("pc.anchorQual") }}</span>
      <span v-if="userState == 1" class="apple-status success">{{
        $t("anchor.cer")
      }}</span>
      <span v-else class="apple-status fail">{{ $t("anchor.cerNot") }}</span>
    </router-link>
    <!-- <router-link to="/user-center/watchHistory" active-class="active">
      <img
        src="./img/history_on.png"
        alt=""
        v-if="$route.path == '/user-center/watchHistory'"
      />
      <img src="./img/history.png" alt="" v-else />
      <span>观看历史</span>
    </router-link>
    <router-link
      v-show="hasOrder && appConfig.quiz_factor & 1"
      to="/user-center/betHistory"
      active-class="active"
    >
      <img
        src="./img/bet_on.png"
        alt=""
        v-if="$route.path == '/user-center/betHistory'"
      />
      <img src="./img/bet.png" alt="" v-else />
      <span>鹰选历史</span>
    </router-link>
    <router-link to="/user-center/rechargeHistory" active-class="active">
      <img
        src="./img/recharge-select.png"
        alt=""
        v-if="$route.path == '/user-center/rechargeHistory'"
      />
      <img src="./img/recharge.png" alt="" v-else />
      <span>充值记录</span>
    </router-link>
    <router-link to="/user-center/privateChat" active-class="active">
      <img
        src="./img/private-chat.png"
        alt=""
        v-if="$route.path == '/user-center/privateChat'"
      />
      <img src="./img/private-chat1.png" alt="" v-else />
      <span>聊天消息</span>
      <span class="note" v-show="unreadTotal">{{ unreadTotal }}</span>
    </router-link> -->
    <!-- 更换头像弹窗 -->
    <el-dialog
      :title="$t('user.change')"
      :visible.sync="visibleAvator"
      width="436px"
      :show-close="false"
    >
      <ul class="avator_list">
        <li
          v-for="item in avatorList"
          :key="item.id"
          @click="clickImg(item)"
          :class="item.id == itemAvatorId ? 'active_li' : ''"
        >
          <img :src="item.image_url" alt="" />
        </li>
      </ul>
      <span slot="footer" class="dialog-footer-my">
        <!-- <el-button @click="visibleAvator = false">取 消</el-button>
        <el-button type="primary" @click="visibleAvator = false"
          >确 定</el-button
        > -->
        <el-button class="cancel" @click="visibleAvator = false">{{
          $t("user.cancelText")
        }}</el-button>
        <el-button class="confirm" type="primary" @click="confirmAvatar">{{
          $t("user.modalConfirmText")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 修改昵称弹窗 已修改过-->
    <el-dialog
      title="更换昵称"
      :visible.sync="visibleDisabledNick"
      width="452px"
      :show-close="true"
    >
      <div style="padding-bottom: 30px">
        <header class="flex-between nickname_header">
          <span style="color: #666">当前昵称</span>
          <span style="color: #333; font-weight: 500">{{
            userInfo.nick_name
          }}</span>
        </header>
        <p style="line-height: 16px; font-size: 12px">
          您在最近7天内更改过昵称，近期无法再次更改您的昵称，
          上次更改时间：<span style="color: #0dc286">{{
            $util.format(userInfo.nick_name_time * 1000, "yyyy/MM/dd")
          }}</span>
        </p>
      </div>
    </el-dialog>

    <!-- 修改昵称弹窗 未修改过-->
    <el-dialog
      title="更换昵称"
      :visible.sync="visibleEditNick"
      width="432px"
      :show-close="false"
    >
      <el-form
        label-width="75px"
        label-position="left"
        style="margin-left: 0.24rem; margin-top: 0.24rem"
      >
        <el-form-item label="修改昵称">
          <el-input
            v-model="nick_name"
            placeholder="输入新的昵称(2-8位)"
            style="width: 304px"
            maxlength="8"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input
            v-model="userInfo.formatPhone"
            style="width: 304px"
            readonly
          >
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" style="margin-bottom: 48px">
          <el-input
            v-model="code"
            placeholder="请输入验证码"
            style="width: 304px"
            maxlength="6"
          >
            <div
              slot="suffix"
              :class="[!isSend ? 'send_class' : 'last_down_time']"
              @click="beforeSendCode"
            >
              {{ sendText }}
            </div>
          </el-input>
        </el-form-item>

        <SlideVerify
          v-if="showSlideVerify"
          class="slide-verify-pos"
          :h="171"
          :w="280"
          :sw="40"
          :sh="49"
          @success="verifySuccess"
          @close="showSlideVerify = false"
        />
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="visibleEditNick = false"
          >取消</el-button
        >
        <el-button class="confirm" type="primary" @click="editNick"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <!--      <RechargeDialog ref="RechargeDialog"></RechargeDialog>-->
    <!--    <user-recharge-->
    <!--      :visibleAddMoney="visibleAddMoney"-->
    <!--      @toCancelRecharge="toCancelRecharge"-->
    <!--    />-->
    <!-- 充值弹窗可以抽离组件--》》 -->
    <!-- <el-dialog
      title="充值"
      :visible.sync="visibleAddMoney"
      width="496px"
      :show-close="false"
    >
      <div class="same_text">购买数量</div>
      <ul class="number_list">
        <li
          v-for="item in moneyList"
          :key="item.id"
          @click="changeNumber(item)"
          :class="[changeNumberId == item.id ? 'active_li' : '']"
        >
          <div class="top_d">
            <img src="./img/mine_top_jinkela.png" alt="" />
            <span>{{ item.m }}</span>
          </div>
          <div class="bottom_d">
            <span style="font-size:10px">￥</span>
            <span>{{ item.t }}</span>
          </div>
        </li>
      </ul>
      <div class="item_money">
        <span class="other_money">其他金额</span>
        <el-input
          v-model="inputMoney"
          placeholder="输入金额1000-99999的整数"
          style="width:368px"
        ></el-input>
      </div>
      <div class="same_text">支付方式</div>
      <ul class="pay_method">
        <li
          v-for="item in payList"
          :key="item.id"
          @click="changePay(item)"
          :class="[payMethodId == item.id ? 'active_li' : '']"
        >
          <img :src="item.g" alt="" />
          <span>{{ item.m }}</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer-my">
        <div class="cancel" @click="visibleAddMoney = false">取消</div>
        <div class="confirm" @click="visibleAddMoney = false">确认</div>
      </span>
    </el-dialog> -->
    <!-- 《《充值弹窗 -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { post } from "@/util/http";
import RechargeDialog from "@/components/dialog/RechargeDialog";
import SlideVerify from "@/components/slide-verify";
export default {
  components: {
    RechargeDialog,
    SlideVerify,
  },
  name: "user-tab",

  computed: {
    ...mapState(["userInfo", "appConfig"]),
    ...mapGetters(["userState", "unreadTotal"]),
    activeInfo() {
      const { path } = this.$route;
      return (
        path === "/user-center" ||
        path === "/user-center/edit" ||
        path === "/user-center/bind-phone" ||
        path === "/user-center/recharge" ||
        path === "/user-center/verify"
      );
    },
    liveUrl() {
      return !this.userInfo.is_anchor
        ? "/user-center/become-anchor"
        : "/live/" + this.userInfo.id;
    },
  },
  data() {
    return {
      showSlideVerify: false,
      isAnchorCenter: false,
      visibleEditNick: false,
      visibleDisabledNick: false,
      visibleAvator: false,
      itemAvatorId: "",
      avatarImg: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      nick_name: "",
      // 验证码
      code: "",
      avatorList: [],
      isSend: false,
      sendText: "点击发送",
      //充值弹窗  可以抽离封装--
      moneyList: [
        { id: "0", m: 10, t: 100 },
        { id: "1", m: 20, t: 100 },
        { id: "2", m: 30, t: 100 },
        { id: "3", m: 40, t: 100 },
        { id: "4", m: 50, t: 100 },
        { id: "5", m: 60, t: 100 },
        { id: "6", m: 70, t: 100 },
        { id: "7", m: 80, t: 100 },
      ],
      payList: [
        { id: "1", m: "微信", g: require("./img/mine_pay_weixin.png") },
        { id: "2", m: "支付宝", g: require("./img/mine_pay_zhifubao.png") },
        { id: "3", m: "银行卡", g: require("./img/mine_pay_yinhangka.png") },
      ],
      visibleAddMoney: false,
      changeNumberId: "0",
      payMethodId: "1",
      inputMoney: "",
      //--充值弹窗  可以抽离封装
      hasOrder: JSON.parse(localStorage.getItem("isGuessList")) ? true : false,
    };
  },

  mounted() {
    if (!localStorage.getItem("userInfo")) {
      this.$router.push("/");
      return;
    }
    this.getHasOrder();
    this.getAvatorList();
    this.getUserInfo();
    this.getAuthInfo();
    if (this.$route.path == "/user-center/center-anchor") {
      this.isAnchorCenter = true;
    } else if (this.$route.path == "/user-center/live-room-settings") {
      this.isAnchorCenter = true;
    } else if (this.$route.path == "/user-center/guessing-management") {
      this.isAnchorCenter = true;
    } else {
      this.isAnchorCenter = false;
    }
  },
  methods: {
    ...mapMutations(["changeUserInfo"]),

    verifySuccess() {
      this.showSlideVerify = false;

      this.sendCode();
    },

    beforeSendCode() {
      if (this.isSend) return;

      if (!this.nick_name) {
        return this.$message.warning("请输入用户昵称");
      }

      console.log(this.nick_name.length);
      if (this.nick_name.length > 8 || this.nick_name.length < 2) {
        return this.$message.warning("用户昵称2-8位");
      }

      this.showSlideVerify = true;
    },

    async balanceOut() {
      const { data } = await post({
        url: "/api/game/balance_out",
      });
      if (data.status == 0) {
        this.$message.success("转出成功");
      } else {
        this.$message.error("转出失败");
      }
      console.log(data, "balance");
    },
    async getUserInfo() {
      const { data } = await post({
        url: "/api/user/getUserInfo",
      });
      if (data.status == 0) {
        let { mobile = "" } = data.data;
        if (mobile) {
          let reg = /^(\d{3})\d{4}(\d{4})$/;
          data.data.formatPhone = mobile.replace(reg, "$1****$2");
        }
        let keyValue = {
          ...JSON.parse(localStorage.getItem("userInfo")),
          diamond: data.data.diamond,
          gold: data.data.gold,
          mobile: data.data.mobile,
          formatPhone: data.data.formatPhone,
          ...data.data,
          level: Number(data.data.level) || 0,
          process: Number(data.data.process) || 0,
          remainder: Number(data.data.remainder) || 0,
        };
        localStorage.setItem("userInfo", JSON.stringify(keyValue));
        this.changeUserInfo({
          ...keyValue,
        });
      }
    },
    async getAuthInfo() {
      const {
        data: { data, status, msg },
      } = await post({
        url: "/api/auth/getAuthInfo",
      });
      if (status == 0) {
        this.$store.commit("setUserState", data.status);
      }
    },
    //充值弹窗  可以抽离封装--
    recharge() {
      this.$router.push("/user-center/recharge");
    },
    // toCancelRecharge(item) {
    //   this.changeNumberId = item.id;
    //   this.inputMoney = item.m;
    // },
    // changePay(item) {
    //   this.payMethodId = item.id;
    // },
    //--充值弹窗  可以抽离封装
    // toCancelRecharge() {
    //   this.visibleAddMoney = false;
    // },
    editInfo() {
      if (
        this.userInfo.nick_name_time === 0 ||
        Date.now() - this.userInfo.nick_name_time * 1000 >
          7 * 24 * 60 * 60 * 1000
      ) {
        this.visibleEditNick = true;
      } else {
        this.visibleDisabledNick = true;
      }
      console.log("个人资料", this.visibleEditNick, this.visibleDisabledNick);
    },
    changeAvator() {
      this.visibleAvator = true;
    },
    clickImg(item) {
      this.itemAvatorId = item.id;
      this.avatarImg = item.image_url;
    },
    async getAvatorList() {
      const {
        data: { data, status, msg },
      } = await post({
        url: "/api/user/defaultAvatar",
      });
      if (status == 0) {
        this.avatorList = data.defult_avatar;
      }
    },
    async confirmAvatar() {
      if (!this.itemAvatorId) {
        return this.$message.warning(this.$t("info.chooseAvatar"));
      }
      const {
        data: { data, status, msg },
      } = await post({
        url: "/api/user/editUserInfo",
        data: { avatarId: this.itemAvatorId },
      });

      if (status == 0) {
        console.log(data, "----data");
        this.visibleAvator = false;
        // this.userInfo.avatar = this.avatarImg;
        this.changeUserInfo({
          ...this.userInfo,
          avatar: this.avatarImg,
        });
        this.$message.success(this.$t("pc.changeSuccess"));
      }
    },
    async editNick() {
      if (!this.code) {
        return this.$message.warning("验证码不能为空");
      }
      try {
        const {
          data: { data, status, msg },
        } = await post({
          url: "/api/user/editUserInfo",
          data: {
            nick_name: this.nick_name,
            mobile: this.userInfo.mobile,
            code: this.code,
          },
        });

        if (status === 0) {
          console.log(data, "----data");
          this.visibleEditNick = false;
          this.getUserInfo();
          this.$message.success("修改成功！");
        }
      } catch (e) {
        // this.$message.warning(e.message);
      }
    },

    async sendCode() {
      const {
        data: { data, status, msg },
      } = await post({
        url: "/api/user/sendVerifyCode",
        data: { mobile: this.userInfo.mobile },
      });
      if (status == 0) {
        this.$message.success("发送成功");
        this.isSend = true;
        let time = 60;
        this.sendText = time + "s";
        let timeId = setInterval(() => {
          time--;
          this.sendText = time + "s";
          if (time <= 0) {
            this.sendText = "重新发送";
            this.isSend = false;
            clearInterval(timeId);
          }
        }, 1000);
      }
    },

    getHasOrder() {
      let data = {
        page: 1,
        size: 10,
        uid: this.userInfo.id,
        status: 0,
      };
      // console.log(data)
      post({
        url: "/api/guess/getGuessOrderList",
        data,
      })
        .then(({ data: { data } }) => {
          let total = data.total || 0;
          this.hasOrder = total > 0 ? true : false;
          localStorage.setItem("isGuessList", this.hasOrder);
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/variable.scss";
.slide-verify-pos {
  position: absolute;
  max-width: 350px;
  top: 35px;
  left: 50%;
  transform: translate3d(-50%, 10px, 10px);
  background-color: #fff;
}
::v-deep .el-input--small .el-input__inner {
  height: 0.4rem;
}
//充值弹窗  可以抽离封装--
.same_text {
  margin-top: 24 * 0.01rem;
  margin-bottom: 16 * 0.01rem;
  font-size: 14 * 0.01rem;
  color: #666666;
  padding-left: 24 * 0.01rem;
}
.other_money {
  font-size: 14 * 0.01rem;
  color: #666666;
  padding-left: 24 * 0.01rem;
  margin-right: 24 * 0.01rem;
}

.nickname_header {
  border-bottom: 1px solid #ddd;
  line-height: 0.4rem;
  margin-bottom: 4px;
}
.number_list {
  display: flex;
  flex-wrap: wrap;
  padding-left: 24 * 0.01rem;

  li {
    width: 100 * 0.01rem;
    height: 88 * 0.01rem;
    background: rgba(38, 217, 157, 0.1);
    // border: 1px solid transparent;
    background: #f7f7f7;
    border-radius: 8 * 0.01rem;
    margin-right: 16 * 0.01rem;
    box-sizing: border-box;
    margin-bottom: 16 * 0.01rem;
    // overflow hidden
    cursor pointer .top_d {
      height: 56 * 0.01rem;
      font-size: 14 * 0.01rem;
      color: #666666;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 8px 8px 0 0;
      img {
        width: 16 * 0.01rem;
        height: 16 * 0.01rem;
        margin-right: 4 * 0.01rem;
      }
    }
    .bottom_d {
      // width: 100* 0.01rem;
      height: 32 * 0.01rem;
      background: #f0f0f0;
      font-size: 20 * 0.01rem;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0 0 8px 8 * 0.01rem;
    }
  }
  .active_li {
    width: 100 * 0.01rem;
    height: 88 * 0.01rem;
    background: rgba(38, 217, 157, 0.1);

    border-radius: 8 * 0.01rem;
    .top_d {
      height: 56 * 0.01rem;
      font-size: 14 * 0.01rem;
      color: #26d99d;
      border: 1px solid #26d99d;
      border-bottom: none;
    }
    .bottom_d {
      background: #26d99d;
      color: #ffffff;
    }
  }
}
.pay_method {
  padding-left: 24 * 0.01rem;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 48 * 0.01rem;
  li {
    width: 106 * 0.01rem;
    height: 48 * 0.01rem;
    background: #f7f7f7;
    border-radius: 8 * 0.01rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14 * 0.01rem;
    color: #666666;
    overflow: hidden;
    margin-right: 16 * 0.01rem;
    cursor pointer img {
      width: 24 * 0.01rem;
      height: 24 * 0.01rem;
      margin-right: 8 * 0.01rem;
    }
  }
  .active_li {
    background: linear-gradient(101.98deg, #FF3838 10.8%, #D02D54 95.33%);
    border: 1px solid #FF3838;
  }
}
//--充值弹窗  可以抽离封装
.user-tab {
  width: 280 * 0.01rem;
  height: 934 * 0.01rem;
  box-sizing: border-box;
  background: #f7f7f7;
  border-radius: 0px 0px 0px 16 * 0.01rem;

  .avator_list {
    display: flex;
    padding-left: 28 * 0.01rem;
    padding-right: 6 * 0.01rem;
    margin-top: 28 * 0.01rem;
    flex-wrap: wrap;
    margin-bottom: 48 * 0.01rem;
    li {
      margin-right: 20 * 0.01rem;
      width: 80 * 0.01rem;
      height: 80 * 0.01rem;
      border-radius: 50%;
      overflow: hidden;
      margin-bottom: 16 * 0.01rem;
      cursor: pointer;
      box-sizing: border-box;
      border: 1px solid transparent;
      img {
        width: 80 * 0.01rem;
        height: 80 * 0.01rem;
        border-radius: 50%;

        box-sizing: border-box;
      }
    }
    .active_li {
      border: 1px solid #FF3838;
      img {
      }
    }
  }

  .user-info {
    width: 100%;
    height: 214 * 0.01rem;
    background: url("~@/assets/user/user_bg.png");
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .avator {
      img {
        background-image: linear-gradient(
          to right,
          rgba(255, 56, 56, 1),
          rgba(208, 45, 84, 1)
        );
        padding: 2 * 0.01rem;
        width: 80 * 0.01rem;
        height: 80 * 0.01rem;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
      }
    }
    .nick_name {
      font-size: 16 * 0.01rem;
      color: #333333;
      margin-top: 16 * 0.01rem;
      font-weight: 700;
      display: flex;
      align-items: center;
      img {
        width: 22 * 0.01rem;
        height: 22 * 0.01rem;
        margin-left: 8 * 0.01rem;
        cursor: pointer;
      }
    }
    .name_id {
      font-size: 14 * 0.01rem;
      color: #666666;
      margin-top: 8 * 0.01rem;
    }
    .money_append {
      display: flex;
      align-items: center;
      margin-top: 12 * 0.01rem;
      .money {
        font-size: 0.14rem;
        // color: #26d99d;
        color: #666666;
        letter-spacing: 0;
        font-weight: 500;
        .top {
          display: flex;
          align-items: center;
          img {
            width: 0.18rem;
            height: 0.18rem;
            margin-right: 0.05rem;
          }
        }
        .num {
          margin-top: 0.05rem;
          text-align: center;
        }

        .up {
          display: flex;
          margin-bottom: 0.02rem;
        }

        .down {
          display: flex;
        }
      }
      .line {
        width: 1 * 0.01rem;
        height: 16 * 0.01rem;
        background: rgba(0, 0, 0, 0.1);
        margin-right: 12 * 0.01rem;
        margin-left: 12 * 0.01rem;
      }
      .pay_money {
        font-size: 14 * 0.01rem;
        color: #333333;
        cursor: pointer;
      }
    }
  }
  .user-title {
    font-size: 24 * 0.01rem;
    color: #333333;
    margin-top: 41 * 0.01rem;
    font-weight: 600;
    height: 23 * 0.01rem;
    width: 100%;
    padding-left: 95 * 0.01rem;
  }

  .user-item {
    img {
      width: 24 * 0.01rem;
      height: 24 * 0.01rem;
      margin-left: 18 * 0.01rem;
      margin-right: 16 * 0.01rem;
    }
  }
  .activeAnchor {
    font-weight: 700;
    color: rgba(253, 48, 97, 1);
    box-sizing: border-box;
    border-left: 0.04rem solid rgba(255, 118, 151, 1);
    background: linear-gradient(90deg, #ffb8b8 0%, #ffe6c9 100%);
  }
  .scd-menu {
    .scd-menu-item {
      display: flex;
      padding: 0.11rem 0rem 0.11rem 0.6rem;
      background-color: #f9f9fb;
      font-weight: 400;
      font-size: 0.14rem;
      line-height: 0.2rem;
      color: #999999;
    }
    .scd-menu-item-active {
      display: flex;
      padding: 0.11rem 0rem 0.11rem 0.6rem;
      background-color: #f9f9fb;
      color: #02a8a2;
      font-weight: 400;
      font-size: 0.14rem;
      line-height: 0.2rem;
    }
  }
  .apple-status {
    color: #ffffff;
    font-size: 14 * 0.01rem;
    /* width: 70 * 0.01rem; */
    height: 0.28rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: center;
    line-height: 0.28rem;
    margin-left: 0.1rem;
    padding: 0 0.2rem;
    &.success {
      background-image: url("~@/assets/user/tip_bg.png");
    }
    &.fail {
      background-image: url("~@/assets/user/tip_bg.png");
    }
  }
  & > a {
    display: flex;
    align-items: center;
    height: 40 * 0.01rem;
    width: 100%;
    font-size: 16 * 0.01rem;
    color: #333333;
    text-align: center;
    border-left: 3px solid transparent;
    & > .tab_item_icon {
      font-size: 40 * 0.01rem;
      color: #026475;
    }
    .note {
      padding: 0 0.05rem;
      min-width: 0.1rem;
      height: 0.2rem;
      line-height: 0.2rem;
      text-align: center;
      border-radius: 0.2rem;
      background: #f64d5c;
      color: #ffffff;
      font-size: 0.12rem;
      margin-left: 0.06rem;
    }

    img {
      width: 24 * 0.01rem;
      height: 24 * 0.01rem;
      margin-left: 18 * 0.01rem;
      margin-right: 16 * 0.01rem;
    }

    &.active {
      color: rgba(253, 48, 97, 1);
      box-sizing: border-box;
      border-left: 4px solid rgba(255, 118, 151, 1);
      background: linear-gradient(90deg, #ffb8b8 0%, #ffe6c9 100%);
      :first-child {
        color: rgba(253, 48, 97, 1);
      }
      span {
        font-weight: 700;
      }
    }
  }
}
</style>
